module.exports = __webpack_public_path__ + "static/media/giphy02.f2c126fc.mp4";